import { render, staticRenderFns } from "./Attribut.vue?vue&type=template&id=6d70c76a&scoped=true&"
import script from "./Attribut.vue?vue&type=script&lang=js&"
export * from "./Attribut.vue?vue&type=script&lang=js&"
import style0 from "./Attribut.vue?vue&type=style&index=0&id=6d70c76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d70c76a",
  null
  
)

export default component.exports